import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full px-4 md:px-6 py-8 bg-background-100 border-t border-foreground-200">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Link to="/" className="text-sm font-heading font-semibold text-foreground-800 hover:text-primary-500 transition-colors duration-200">
            CSS Spreadsheet
          </Link>
          <span className="text-foreground-300 text-sm">|</span>
          <span className="text-xs text-foreground-400">Trusted spreadsheet directory for shopping agents</span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/article/cssbuy-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">
            Complete Guide
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200"
          >
            Main Platform
          </a>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-4 pt-4 border-t border-foreground-100">
        <p className="text-xs text-foreground-400 text-center">
          &copy; {new Date().getFullYear()} CSS Spreadsheet. This site provides informational spreadsheet recommendations. All external product links direct to third-party platforms.
        </p>
      </div>
    </footer>
  );
}